import {
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { useTranslation } from "react-i18next";
import { DailyMetric } from "../../api/types";

export default function FollowerGrowthChart({ data }: { data: DailyMetric[] }) {
  const { t } = useTranslation();
  const series = data.map((d) => ({
    date: d.date,
    followers: d.followers,
    following: d.following,
  }));

  return (
    <ResponsiveContainer width="100%" height={260}>
      <LineChart data={series}>
        <CartesianGrid strokeDasharray="3 3" stroke="#334155" />
        <XAxis dataKey="date" tick={{ fill: "#94a3b8", fontSize: 12 }} />
        <YAxis tick={{ fill: "#94a3b8", fontSize: 12 }} domain={["auto", "auto"]} />
        <Tooltip
          contentStyle={{
            background: "#0f172a",
            border: "1px solid #334155",
            borderRadius: 8,
            color: "#e2e8f0",
          }}
        />
        <Legend wrapperStyle={{ color: "#cbd5e1", fontSize: 12 }} />
        <Line
          type="monotone"
          dataKey="followers"
          stroke="#d138ff"
          strokeWidth={2}
          dot={{ r: 3, fill: "#d138ff" }}
          activeDot={{ r: 5 }}
          name={t("dashboard.charts.followers")}
        />
        <Line
          type="monotone"
          dataKey="following"
          stroke="#34d399"
          strokeWidth={2}
          strokeDasharray="4 3"
          dot={{ r: 2, fill: "#34d399" }}
          activeDot={{ r: 4 }}
          name={t("dashboard.charts.following")}
        />
      </LineChart>
    </ResponsiveContainer>
  );
}
